/* eslint-disable camelcase */
import { getPlatform } from 'utils/token/token'
import { getEnvPath, findOutWhichEnv } from '../../utils/env'
import { getHeaders, handleErrors } from './utils'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

async function authorizeAdsAccount() {
  const platform = getPlatform()

  const response = await fetch(`${BASE_PATH}/meta/authorize?platform=${platform}`, getHeaders('GET')).then((res) =>
    res.json(),
  )
  return handleErrors(response)
}

async function getAdAccountConnectedList() {
  const data = await fetch(`${BASE_PATH}/meta/accounts`, getHeaders('GET'))
  const response = await data.json()
  return handleErrors(response)
}

async function getAdAccounts() {
  const data = await fetch(`${BASE_PATH}/meta/ad_accounts`, getHeaders('GET'))
  const response = await data.json()
  return handleErrors(response)
}

/**
 * @param {string} adAccountId
 * @returns Promise
 */
async function inactivateAdAccount(adAccountId) {
  if (!adAccountId) return null
  const data = await fetch(`${BASE_PATH}/meta/inactivate?id=${adAccountId}`, getHeaders('DELETE'))
  const response = await data.json()
  return handleErrors(response)
}

async function getDefaultEvents() {
  const data = await fetch(`${BASE_PATH}/meta_events/default_list`, getHeaders('GET'))
  const response = await data.json()
  return handleErrors(response)
}

async function getEvents() {
  const data = await fetch(`${BASE_PATH}/meta_events/list`, getHeaders('GET'))
  const response = await data.json()
  return handleErrors(response)
}

async function getEventDetails(metaEventId) {
  const data = await fetch(`${BASE_PATH}/meta_events/details?id=${metaEventId}`, getHeaders('GET'))
  const response = await data.json()
  return handleErrors(response)
}

/**
 * Updates the status of a meta event.
 *
 * @param {object} props - The parameters for updating the meta event.
 * @param {number} props.meta_event_id - The ID of the meta event to update.
 * @param {boolean} props.is_active - The new status of the meta event.
 * @returns {Promise} - A promise that resolves to the updated meta event data.
 */
async function updateStatusMetaEvent({ meta_event_id, is_active }) {
  const data = await fetch(`${BASE_PATH}/meta_events/update_status`, getHeaders('PUT', { meta_event_id, is_active }))
  const response = await data.json()
  return handleErrors(response)
}

/**
 * Registers events with the specified parameters.
 * @async
 * @param {Object} params - The parameters for registering events.
 * @param {string} params.event_id - The ID of the event to be registered.
 * @param {Array<string>} params.department_ids - An array of department IDs associated with the event.
 * @param {Array<string>} params.channels - An array of channels for the event.
 * @returns {Promise} A promise that resolves to the response data after error handling.
 */
async function registerEvents({ event_id, department_ids, channels }) {
  const data = await fetch(`${BASE_PATH}/meta_events/save`, getHeaders('POST', { event_id, department_ids, channels }))
  const response = await data.json()
  return handleErrors(response)
}

export {
  getAdAccountConnectedList,
  getAdAccounts,
  inactivateAdAccount,
  authorizeAdsAccount,
  getDefaultEvents,
  getEvents,
  getEventDetails,
  registerEvents,
  updateStatusMetaEvent,
}
